import React, { useState } from 'react';
import { Modal } from 'antd';
import { UploadFile, Visibility } from '@app/components';
import { Button, Col, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { updateDesobrigarConfide } from '@app/api/sas/sasProposta';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { editandoState, modalAcoesIdState, reloadVendorListState, showModalDesobrigarConfideIdState } from '../atoms';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';

const ModalDesobrigarConfide = () => {
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [showId, setShowId] = useRecoilState(showModalDesobrigarConfideIdState);
    const [editando, setEditando] = useRecoilState(editandoState);
    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const [exibirModal, setExibirModal] = useState(true);

    const handleCancel = () => {
        setModalAcoesId('');
        setShowId('');
        setExibirModal(false);
    };

    const handleSubmit = (values: any) => {
        const form = new FormData();
        form.append('sasPropostaId', showId);
        form.append('arquivo', values.arquivo);
        form.append('comentarioDesobrigrarConfide', values.comentarioDesobrigrarConfide);

        Modal.confirm({
            title: '',
            content: `Confirma desobrigrar do Relatório Financeiro ?`,
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {

                if (editando.sasPropostaId == showId) {
                    Modal.confirm({
                        title: <>{editando.justificativa}</>,
                        content: <ModalConfirmContentJustificativa
                            texto='É necessário informar a justificativa para a alteração.'
                            setJustificativa={e => {
                                form.set('justificativaEdicao', e);
                            }}
                        />,
                        okText: 'Confirmar',
                        cancelText: 'Cancelar',
                        onOk: async (e) => {
                            form.append('editando', 'true');
                            return new Promise((resolve, reject) => {
                                updateDesobrigarConfide(form)
                                    .then((data: any) => {
                                        if (data && data.valid) {
                                            setReloadVendorList(!reloadVendorList);
                                            handleCancel();
                                            return resolve(true);
                                        } else {
                                            if (data.notifications && data.notifications.length > 0) {
                                                const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                                    return c.property == 'justificativaEdicao'
                                                })
                                                if (erroJustificativaEdicao >= 0) {
                                                    return reject(false);
                                                }
                                            }
                                        }
                                    });
                            });
                        },
                        onCancel: () => { setModalAcoesId(''); }
                    });
                } else {
                    updateDesobrigarConfide(form)
                        .then((data: any) => {
                            if (data && data.valid) {
                                setReloadVendorList(!reloadVendorList);
                                handleCancel();

                            }
                        });
                }
            }
        });
    };

    return (
        <>
            <Modal title={`Desobrigar Relatório Financeiro`} width='980px' visible={exibirModal} onCancel={handleCancel} footer={null} >
                <Visibility visible={exibirModal} >
                    <MasterDetailForm
                        key={`formDesobrigarConfide_${showId}`}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                        ]}
                    >
                        <Row>
                            <FormTextArea name='comentarioDesobrigrarConfide' label='Justificativa' required />
                        </Row>
                        <Row>
                            <Col span={6}>
                                <br></br>
                                <UploadFile
                                    nameFormData='arquivo'
                                    idDoComponente='arquivo'
                                    type='primary'
                                    hasFile={false}
                                    hasLabel={true}
                                    label={'Adicionar Arquivo'}
                                    icon='ui-upload'
                                    span={6}
                                />
                            </Col>
                        </Row>
                    </MasterDetailForm>
                </Visibility>
            </Modal>
        </>
    );
};

export default ModalDesobrigarConfide;